export const defaultCardTheme = {
  preset: "ofc-default",
  primary: "#1b8395",
  secondary: "#20acad",
  accent: "#f9c534",
  background: "#f2f4f7",
  surface: "#ffffff",
  text: "#111827",
  font: "system",
  radius: "rounded",
};

export const cardThemePresets = [
  {
    id: "ofc-default",
    label: "Default OFC",
    description: "Palette attuale Cards.",
    colors: {
      primary: "#1b8395",
      secondary: "#20acad",
      accent: "#f9c534",
      background: "#f2f4f7",
      surface: "#ffffff",
      text: "#111827",
    },
  },
  {
    id: "elegante-scura",
    label: "Elegante scura",
    description: "Petrolio e oro, più istituzionale.",
    colors: {
      primary: "#0f3d4a",
      secondary: "#1f7a8c",
      accent: "#d9a441",
      background: "#eef3f5",
      surface: "#ffffff",
      text: "#102027",
    },
  },
  {
    id: "chiara-professionale",
    label: "Chiara professionale",
    description: "Toni chiari e accento verde acqua.",
    colors: {
      primary: "#25636f",
      secondary: "#47b8a5",
      accent: "#f2c94c",
      background: "#f7fafb",
      surface: "#ffffff",
      text: "#172033",
    },
  },
  {
    id: "istituzionale",
    label: "Istituzionale",
    description: "Blu classico, contrasto pulito.",
    colors: {
      primary: "#1f4f7a",
      secondary: "#4f8fc7",
      accent: "#f0b429",
      background: "#eef2f6",
      surface: "#ffffff",
      text: "#111827",
    },
  },
];

export const cardThemeFonts = [
  {
    id: "system",
    label: "Default sans",
    family:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  {
    id: "serif",
    label: "Serif elegante",
    family: 'Georgia, Cambria, "Times New Roman", Times, serif',
  },
  {
    id: "geometric",
    label: "Geometrico",
    family:
      'Avenir, Montserrat, "Nunito Sans", ui-sans-serif, system-ui, sans-serif',
  },
  {
    id: "classic",
    label: "Classico",
    family: 'Arial, Helvetica, ui-sans-serif, system-ui, sans-serif',
  },
];

export const cardThemeRadiusOptions = [
  {
    id: "rounded",
    label: "Stondata",
    cardClassName: "rounded-2xl",
    panelClassName: "rounded-xl",
    buttonClassName: "rounded-xl",
    iconClassName: "rounded-lg",
    avatarClassName: "rounded-full",
  },
  {
    id: "soft",
    label: "Morbida",
    cardClassName: "rounded-xl",
    panelClassName: "rounded-lg",
    buttonClassName: "rounded-lg",
    iconClassName: "rounded-md",
    avatarClassName: "rounded-full",
  },
  {
    id: "square",
    label: "Squadrata",
    cardClassName: "rounded-md",
    panelClassName: "rounded-md",
    buttonClassName: "rounded-md",
    iconClassName: "rounded-sm",
    avatarClassName: "rounded-md",
  },
];

export const cardThemeFieldNames = [
  "themePreset",
  "themePrimary",
  "themeSecondary",
  "themeAccent",
  "themeBackground",
  "themeSurface",
  "themeText",
  "themeFont",
  "themeRadius",
];

export const isValidHexColor = (value = "") =>
  /^#[0-9a-fA-F]{6}$/.test(String(value).trim());

const normalizeHex = (value, fallback) => {
  const normalized = String(value || "").trim();
  return isValidHexColor(normalized) ? normalized : fallback;
};

export const getCardThemePreset = (presetId = "") =>
  cardThemePresets.find((preset) => preset.id === presetId) ||
  cardThemePresets[0];

export const getCardTheme = (card = {}) => {
  const preset = getCardThemePreset(card.themePreset || defaultCardTheme.preset);
  const presetColors = preset.colors;
  const font =
    cardThemeFonts.find((item) => item.id === card.themeFont) ||
    cardThemeFonts[0];
  const radius =
    cardThemeRadiusOptions.find((item) => item.id === card.themeRadius) ||
    cardThemeRadiusOptions[0];

  return {
    presetId: card.themePreset || preset.id,
    colors: {
      primary: normalizeHex(card.themePrimary, presetColors.primary),
      secondary: normalizeHex(card.themeSecondary, presetColors.secondary),
      accent: normalizeHex(card.themeAccent, presetColors.accent),
      background: normalizeHex(card.themeBackground, presetColors.background),
      surface: normalizeHex(card.themeSurface, presetColors.surface),
      text: normalizeHex(card.themeText, presetColors.text),
    },
    font,
    radius,
  };
};

export const buildCardThemeFieldsFromPreset = (presetId) => {
  const preset = getCardThemePreset(presetId);

  return {
    themePreset: preset.id,
    themePrimary: preset.colors.primary,
    themeSecondary: preset.colors.secondary,
    themeAccent: preset.colors.accent,
    themeBackground: preset.colors.background,
    themeSurface: preset.colors.surface,
    themeText: preset.colors.text,
  };
};

export const buildDefaultCardThemeFields = () => ({
  ...buildCardThemeFieldsFromPreset(defaultCardTheme.preset),
  themeFont: defaultCardTheme.font,
  themeRadius: defaultCardTheme.radius,
});
